const isEmpty = (val) => {
  return val === null || val === undefined || val === ''
}
export default isEmpty
